import type { OrganizationType } from '@common/enums';
import { organizationTypesWithRightsToCreateAccountsAndEndEmployments } from '@common/enums';
import { ManagerAuthorization } from '@common/enums/managerAuthorization';
import { checkListForOneAuthorization } from '@common/utils/checkListForAuthorization';
import { store } from '@frontend/configureStore';

export function hasOneAuthorization(authorizations: ManagerAuthorization | ManagerAuthorization[]): boolean {
    const userAuthorizations: ManagerAuthorization[] =
        store.getState()?.authentication?.managerRole?.authorizations ?? [];

    return checkListForOneAuthorization(authorizations, userAuthorizations);
}

export type AccountRequestAuthorizationType = 'create' | 'update' | 'delete' | 'review' | 'read';

export function hasAccountRequestAuthorization(type: 'create' | 'read', isOnlyForKsyos?: boolean): boolean;
export function hasAccountRequestAuthorization(
    type: 'review',
    isOnlyForKsyos: boolean,
    accountRequestApproverId?: string
): boolean;
export function hasAccountRequestAuthorization(
    type: Exclude<AccountRequestAuthorizationType, 'create' | 'read' | 'review'>
): boolean;
export function hasAccountRequestAuthorization(
    type: AccountRequestAuthorizationType,
    isOnlyForKsyos?: boolean | string,
    accountRequestApproverId?: string
): boolean {
    const { id: userId, organizationType: userOrganizationType } = store.getState().authentication;

    const allowedOrganizationTypes = organizationTypesWithRightsToCreateAccountsAndEndEmployments;

    const hasAuthorizedOrganizationType = allowedOrganizationTypes.includes(userOrganizationType as OrganizationType);

    if (type === 'create') {
        return (
            hasOneAuthorization(ManagerAuthorization.accountRequestReviewAddEdit) ||
            (!isOnlyForKsyos && hasAuthorizedOrganizationType)
        );
    } else if (type === 'delete') {
        return false;
    } else if (type === 'read') {
        return (
            hasOneAuthorization(ManagerAuthorization.practitionerRead) ||
            (!isOnlyForKsyos && hasAuthorizedOrganizationType)
        );
    } else if (type === 'review') {
        return (
            hasOneAuthorization(ManagerAuthorization.accountRequestReviewAddEdit) ||
            (!isOnlyForKsyos && hasAuthorizedOrganizationType && userId === accountRequestApproverId)
        );
    } else if (type === 'update') {
        return hasOneAuthorization([ManagerAuthorization.accountRequestReviewAddEdit]);
    } else {
        return false;
    }
}
